import Header from './components/Header';
import Hero from './components/Hero';
import InfiniteScrollSection from './components/InfiniteScrollSection';
import PerformanceFeatures from './components/PerformanceFeatures';
import Footer from './components/Footer';
import ProductShowcase from './components/ProductShowcase';
import Features from './components/Features';
import BusinessTypes from './components/BusinessTypes';
import BusinessManagement from './components/BusinessManagement';
import ScrollAnimation from './components/ScrollAnimation';
import './App.css';

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div id="home" className="bg-primary-500 overflow-visible">
        <ScrollAnimation variant="fade-in">
          <Hero />
        </ScrollAnimation>
      </div>
            {/* Business Types Section
            <ScrollAnimation variant="fade-up" delay={100}>
        <BusinessTypes />
      </ScrollAnimation> */}
      {/* Infinite Scroll Section – extra top padding for hero video overlap */}
      <ScrollAnimation variant="fade-up" delay={200}>
        <div id="solutions" className="pt-[10vh] md:pt-[14vh] lg:pt-[18vh]">
          <InfiniteScrollSection />
        </div>
      </ScrollAnimation>

      {/* Business Management Section */}
      <ScrollAnimation variant="fade-up" delay={100}>
        <BusinessManagement />
      </ScrollAnimation>
      
      {/* Performance Features Section */}
      <ScrollAnimation variant="zoom-in">
        <div id="performance">
          <PerformanceFeatures />
        </div>
      </ScrollAnimation>

      {/* Product Showcase Section */}
      <ScrollAnimation variant="fade-up">
        <ProductShowcase />
      </ScrollAnimation>

      {/* Features Section */}
      <ScrollAnimation variant="fade-up">
        <Features />
      </ScrollAnimation>

      {/* Footer */}
      <ScrollAnimation variant="fade-in" delay={100}>
        <Footer />
      </ScrollAnimation>
    </div>
  );
}

export default App;
